import React, { useState } from 'react';
import { FormInput } from './forms/FormInput';
import { FormStatus } from './forms/FormStatus';

export default function ContactForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      // Via de eigen API (zelfde route als de aanmeldformulieren); notificatie via SNS
      const apiUrl = import.meta.env.VITE_API_URL?.replace(/\/$/, '') || '';
      const response = await fetch(`${apiUrl}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message
        }),
      });
      
      if (response.ok) {
        // Formulier succesvol verzonden
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
      } else {
        // Fout bij het verzenden van het formulier
        setSubmitStatus('error');
      }
    } catch {
      // Fout bij het verzenden van het formulier
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <form onSubmit={handleSubmit}>
        <div className="space-y-4">
          <FormInput
            id="name"
            name="name"
            label="Naam"
            value={formData.name}
            onChange={handleChange}
            required
          />
          
          <FormInput
            id="email"
            name="email"
            label="E-mail"
            type="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          
          <FormInput
            id="subject"
            name="subject"
            label="Onderwerp"
            value={formData.subject}
            onChange={handleChange}
            required
          />
          
          <FormInput
            id="message"
            name="message"
            label="Bericht"
            value={formData.message}
            onChange={handleChange}
            as="textarea"
            rows={5}
            required
          />
          
          <div className="mt-6">
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full px-4 py-2 bg-[#411217] text-white rounded-lg hover:bg-[#2a0b0e] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSubmitting ? 'Verzenden...' : 'Verstuur bericht'}
            </button>
          </div>
        </div>
      </form>
      
      <div className="mt-4">
        <FormStatus
          status={submitStatus}
          successMessage="Uw bericht is succesvol verzonden. We nemen zo snel mogelijk contact met u op."
          errorMessage="Er is een fout opgetreden bij het verzenden van uw bericht. Probeer het later opnieuw."
        />
      </div>
    </div>
  );
}
